import React, { Component } from 'react';
import Nav from './Nav';
import Home from './Home';
import UsingDrive from './UsingDrive';
import Download from './Download';
import ForBusiness from './ForBusiness';
import {BrowserRouter as Router,Switch,Route,Link} from "react-router-dom";
import DieuHuongURL from './DieuHuongURL';

class App extends Component {
  render() {
    return (
      <Router>
        <div>
        <Nav/>
        {/* <Home/> */}
        {/* <UsingDrive/>
        <Download/>
        <ForBusiness/>
        <Help/> */}
        <DieuHuongURL/>
      </div>
      </Router>
    );
  }
}

export default App;